/* global angular swal, _ */
import './style.less';
import { extend, orderBy, keyBy } from 'lodash';

export default function($log, $location, $stateParams, $anchorScroll, $timeout, ApiClass) {
  'ngInject';

  const vm = this;

  vm.$onInit = activate;
  vm.stateParams = $stateParams;
  vm.activeTrack = $stateParams.track;

  vm.profile_uid = $stateParams.employeeID || $stateParams.id;

  vm.pagination = {
    page: $stateParams.page || 1,
    pageSize: $stateParams.pageSize || 10,
    setPage: pageNo => {
      $location.hash('page-top');
      $location.search('page', pageNo);
      $anchorScroll();
    }
  };

  vm.onClickChangePageSize = size => {
    vm.pagination.page = 1;
    $location.search('page', 1);
    $location.search('pageSize', size);
  };

  vm.onClickChangeTrack = id => {
    vm.activeTrack = id;
    vm.pagination.page = 1;
    $location.search('track', id);
  };

  function activate() {
    vm.loaded = false;
    vm.error = {};

    vm.learningTrack = vm.ngModel;

    ApiClass.learningsGet(
      {},
      {},
      {
        queryParams: {
          profile_uid: vm.profile_uid,
          filters: JSON.stringify({
            active: true,
            requireProgress: true
          }),
          joins: JSON.stringify({ content: true }),
          calc: JSON.stringify({ progress: true })
        }
      }
    )
      .then(({ data: { tracks } }) => {
        if (!tracks.length) {
          vm.loaded = true;
          return;
        }

        const sortedTracks = orderBy(tracks, ['name'], ['asc']);
        const tracksDict = keyBy(tracks, 'track_id');

        vm.tracks = sortedTracks;

        vm.tracks.forEach(track => {
          track.content.forEach(content => {
            const { type, course_id, activity_id, event_id } = content;
            switch (type) {
              case 'activity':
                const activityProgress = track.progress.progress.activities[activity_id];
                extend(content, activityProgress);
                content.status = activityProgress.completed ? 1 : 0;
                break;
              case 'course':
                extend(content, track.progress.progress.courses[course_id]);
                break;
              case 'event':
                extend(content, track.progress.progress.events[course_id]);
                break;
              case 'externalEvent':
                extend(content, track.progress.progress.externalEvents[event_id]);
                break;

              default:
                break;
            }
          });
        });

        if (vm.tracks.length && (!vm.activeTrack || !tracksDict[vm.activeTrack])) {
          vm.activeTrack = vm.tracks[0].track_id;
          $location.search('page', 1);
          $location.search('track', vm.activeTrack);
        }

        $timeout(() => {
          vm.pagination.page = $stateParams.page || 1;
          vm.loaded = true;
        }, 0);
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/users/progressUserTracks/controller.js